import {
  BROADCAST_CREATE_LIVE_RECORDING,
  BROADCAST_DELETE_LIVE_RECORDING,
  BROADCAST_GET_RECORDINGS,
  BROADCAST_SET_RECORDING_STARTING,
  BROADCAST_START_RECORDING,
  BROADCAST_START_RECORDINGS,
  BROADCAST_STOP_RECORDING,
  BROADCAST_STOP_RECORDINGS,
  BROADCAST_SYNC_RECORDINGS,
  BROADCAST_UPDATE_LIVE_RECORDING,
  BROADCAST_UPDATE_RECORDING_REALTIME,
  GET_BROADCAST
} from 'actions/Types';
import {
  splitRecordingsByStatus,
  updateRecordingsFromPayload
} from '../utils/streamHelper';

const initialState = {
  liveRecordings: [],
  pastRecordings: [],
  userId: null
};
export default (state = initialState, action) => {
  if (
    [
      `${GET_BROADCAST}_SUCCESS`,
      `${BROADCAST_CREATE_LIVE_RECORDING}_SUCCESS`,
      `${BROADCAST_DELETE_LIVE_RECORDING}_SUCCESS`,
      `${BROADCAST_UPDATE_LIVE_RECORDING}_SUCCESS`,
      `${BROADCAST_START_RECORDING}_SUCCESS`,
      `${BROADCAST_STOP_RECORDING}_SUCCESS`,
      `${BROADCAST_SET_RECORDING_STARTING}`,
      `${BROADCAST_SYNC_RECORDINGS}_SUCCESS`,
      `${BROADCAST_START_RECORDINGS}_SUCCESS`,
      `${BROADCAST_STOP_RECORDINGS}_SUCCESS`
    ].includes(action.type)
  ) {
    const { recordings, userId } = action.payload;
    return filterRecordings(recordings, userId ? userId : state.userId);
  }

  if (action.type === BROADCAST_DELETE_LIVE_RECORDING) {
    if (!action.payload?.deletedRecordingId) {
      return state;
    }
    const recordings = [...state.liveRecordings, ...state.pastRecordings];
    const updatedRecordings = recordings.filter(
      recording => recording._id !== action.payload.deletedRecordingId
    );
    return filterRecordings(updatedRecordings, state.userId);
  }

  if (action.type === `${BROADCAST_GET_RECORDINGS}_SUCCESS`) {
    return filterRecordings(action.payload);
  }

  if (action.type === `${BROADCAST_UPDATE_RECORDING_REALTIME}`) {
    let recordings = [...state.liveRecordings, ...state.pastRecordings];

    const recordingFromPayload = {
      ...action.payload,
      title: decodeURIComponent(action.payload.title)
    };

    const updatedRecordings = updateRecordingsFromPayload(
      recordings,
      recordingFromPayload
    );
    const { liveRecordings, pastRecordings } =
      splitRecordingsByStatus(updatedRecordings);

    return {
      ...state,
      liveRecordings,
      pastRecordings
    };
  }

  if (
    [
      `${BROADCAST_START_RECORDINGS}_FAILURE`,
      `${BROADCAST_START_RECORDING}_FAILURE`,
      `${BROADCAST_STOP_RECORDINGS}_FAILURE`,
      `${BROADCAST_STOP_RECORDING}_FAILURE`
    ].includes(action.type)
  ) {
    const { userId } = action.payload;
    let liveRecordings = [...state.liveRecordings];
    const error = {
      errorMessage: action.payload.error.message,
      isFailed: true
    };
    const axiosErrorResponse = JSON.parse(action.payload.error.config.data);
    const recordings = [
      `${BROADCAST_START_RECORDINGS}_FAILURE`,
      `${BROADCAST_STOP_RECORDINGS}_FAILURE`
    ].includes(action.type)
      ? getLiveRecordingsWithError(liveRecordings, axiosErrorResponse, error)
      : getLiveRecordingWithError(liveRecordings, axiosErrorResponse, error);

    return filterRecordings(
      [...recordings, ...state.pastRecordings],
      userId ? userId : state.userId
    );
  }

  return state;
};

const getLiveRecordingsWithError = (
  liveRecordings,
  axiosErrorResponse,
  error
) => {
  return liveRecordings.map(recording => {
    const failedRecordings = axiosErrorResponse.payload.recordings;
    if (failedRecordings.includes(recording._id)) {
      return {
        ...recording,
        error
      };
    }
    return recording;
  });
};

const getLiveRecordingWithError = (
  liveRecordings,
  axiosErrorResponse,
  error
) => {
  return liveRecordings.map(recording => {
    if (recording._id === axiosErrorResponse.params.recordingId) {
      return {
        ...recording,
        error
      };
    }
    return recording;
  });
};
const filterRecordings = (recordings, userId) => {
  /**
   * Since the recording title was encoded in the server with encodeURIComponent
   * we need to decode title here with decodeURIComponent before to
   * ensure a friendly readable title.
   */
  const updatedTitles = recordings.map(r => ({
    ...r,
    title: decodeURIComponent(r.title),
    userId
  }));
  const liveRecordings = updatedTitles.filter(rec => !rec.endedAt);
  const pastRecordings = updatedTitles.filter(rec => rec.endedAt);
  return {
    liveRecordings,
    pastRecordings,
    userId
  };
};
